import { Pipe, PipeTransform } from '@angular/core';
import { IStep } from '../../../../shared/interfaces/step.interface';

@Pipe({
  name: 'activeStep',
  standalone: true,
})
export class ActiveStepPipe implements PipeTransform {
  transform(rideStatus: string, rideTimeline: IStep[]): number {
    if (rideStatus.toLowerCase() == 'completed') {
      return rideTimeline.length;
    }
    const activeStep = rideTimeline.find(step => step.active);
    if (activeStep) {
      return rideTimeline.indexOf(activeStep);
    }

    return -1;
  }
}
